import { Pencil } from "lucide-react";
import { ItemHistoryLine } from "./ItemHistoryLine";
import type { ItemDraft } from "./itemDraftsStore";
import { draftChanges } from "./itemHistoryLabels";
import type {
  ItemFieldTarget,
  ItemHistoryActor,
  ItemHistoryContext,
} from "./itemHistoryLabels";
import { buildHistorySentence } from "./itemHistoryRows";

const DRAFT_ACTOR: ItemHistoryActor = {
  name: "You",
  icon: Pencil,
  initials: null,
  imageUrl: null,
  tone: "draft",
  context: "unsaved",
  behalf: null,
};

interface ItemHistoryUnsavedGroupProps {
  draft: ItemDraft | undefined;
  context: ItemHistoryContext;
  onSelectField: (target: ItemFieldTarget) => void;
}

/**
 * The edits the user has not saved yet, pinned above the recorded writes as
 * one line built the same way, so the two read alike.
 * @param draft - The item's open draft, or undefined when none is open
 * @param context - The item and the names ids resolve through
 * @param onSelectField - Jumps the form to a clicked field
 */
export const ItemHistoryUnsavedGroup = ({
  draft,
  context,
  onSelectField,
}: ItemHistoryUnsavedGroupProps) => {
  const changes = draftChanges(draft);
  if (changes.length === 0) {
    return null;
  }

  return (
    <ItemHistoryLine
      actor={DRAFT_ACTOR}
      sentence={buildHistorySentence(changes, context, { created: false })}
      time={null}
      reason={null}
      onSelectField={onSelectField}
    />
  );
};
